import { forwardRef } from "react";
import { HelperText } from "@hireart/component-library";
import { useField } from "formik";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { PhoneTextField } from "../PhoneTextField";

/**
 * FormPhoneTextField wires up PhoneTextField with Formik
 */
export const FormPhoneTextField = forwardRef(
  (
    {
      "aria-describedby": ariaDescribedBy = "",
      className = "",
      country = undefined,
      id = undefined,
      isDisabled = false,
      isOptional = false,
      label,
      name,
      onChange = () => {},
      textFieldClassName = "",
    },
    ref
  ) => {
    const [field, meta] = useField({ name });
    const hasError = meta.touched && !isEmpty(meta.error);
    const inputId = id || name;
    const helperTextIds = [
      hasError ? `${inputId}-error` : undefined,
      ariaDescribedBy,
    ]
      .filter(Boolean)
      .join(" ");

    const handleChange = (e) => {
      field.onChange(e);
      onChange(e, e.target.value);
    };

    return (
      <div className={className}>
        <PhoneTextField
          {...field}
          ref={ref}
          aria-describedby={isEmpty(helperTextIds) ? undefined : helperTextIds}
          className={textFieldClassName}
          country={country}
          hasError={hasError}
          id={inputId}
          isDisabled={isDisabled}
          isOptional={isOptional}
          label={label}
          name={name}
          onChange={handleChange}
        />
        {hasError && (
          <HelperText id={`${inputId}-error`} hasError>
            {meta.error}
          </HelperText>
        )}
      </div>
    );
  }
);

FormPhoneTextField.displayName = "FormPhoneTextField";

FormPhoneTextField.propTypes = {
  "aria-describedby": PropTypes.string,
  className: PropTypes.string,
  country: PropTypes.string,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isOptional: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  textFieldClassName: PropTypes.string,
};
